import minebikers from "../minebikerstext.png";
import mcc from "../mcctext.jpg";

export default function FacebookButton() {

  return (
    <div style={{justifyContent: "center", alignItems: "center", display: "flex", flexDirection: "column", marginTop: "2%"}}>
        <img src={minebikers} alt="minebikers text" />
       
        <a href="https://www.facebook.com/profile.php?id=100092389456753">
      Facebookissa
        </a>
    <img style={{marginTop: "2%"}} src={mcc} alt="mcc text" />
    </div>
  );
}
